/**
 * useGetDropYouTubeVideos — recent uploads from the Drop's connected channel.
 *
 * The fallback behind the hero's video strip: a publisher who has assigned no
 * videos still gets a populated one, without anyone maintaining a list that
 * goes stale on the second upload.
 */
import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropYouTubeVideos(slug?: string) {
    return useQuery({
        queryKey: ["drop-youtube-videos", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            /*
             * No `as any`. The generated client types this endpoint and its
             * response — the cast discarded that for every consumer, which is
             * the drift the repo's "never cast a client response" rule exists
             * to stop. The sibling roster hook makes the same call uncast.
             */
            return api.getDropsSlugSlugContentYoutubeVideos({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 30 * 60 * 1000,
    });
}
